console.log('Swatch switcher loaded');

(function () {

  function swapImages(card, primaryUrl, secondaryUrl) {
    const primaryImg = card.querySelector('.product-card__image--primary');
    const secondaryImg = card.querySelector('.product-card__image--secondary');

    if (!primaryImg || !primaryUrl) return;

    primaryImg.src = primaryUrl;
    primaryImg.srcset = primaryUrl;

    if (secondaryImg) {
      if (secondaryUrl) {
        secondaryImg.style.removeProperty('opacity');
        secondaryImg.src = secondaryUrl;
        secondaryImg.srcset = secondaryUrl;
      } else {
        secondaryImg.style.opacity = '0';
      }
    }
  }

  function updateCardMetadata(card, swatch) {
    const url = swatch.dataset.url;
    const title = swatch.dataset.title;
    const minPrice = swatch.dataset.minPrice;
    const comparePrice = swatch.dataset.comparePrice;

    // 1. Update Title and Links
    const titleEl = card.querySelector('.js-card-title, .product-card__title a, .product-item__title a');
    if (titleEl && title) {
      titleEl.textContent = title;
    }
    
    card.querySelectorAll('a[href]').forEach(link => {
      // Don't overwrite the swatch links themselves
      if (!link.classList.contains('cs-swatch-link') && url) {
        link.setAttribute('href', url);
      }
    });

    // 2. Update Price List Components Instantly
    const salePriceEl = card.querySelector('price-list sale-price');
    const comparePriceEl = card.querySelector('price-list compare-at-price');

    if (salePriceEl && minPrice) {
      salePriceEl.textContent = minPrice;
      
      // Toggle sale classes visually depending on whether a compare price exists
      if (comparePrice) {
        salePriceEl.className = salePriceEl.className.replace('text-subdued', 'text-on-sale');
      } else {
        salePriceEl.className = salePriceEl.className.replace('text-on-sale', 'text-subdued');
      }
    }

    if (comparePriceEl) {
      if (comparePrice) {
        comparePriceEl.textContent = comparePrice;
        comparePriceEl.removeAttribute('hidden');
        comparePriceEl.style.display = ''; // Fallback for basic display logic
      } else {
        comparePriceEl.setAttribute('hidden', 'true');
        comparePriceEl.style.display = 'none';
      }
    }
  }

  function initializeCardState(card) {
    if (card.dataset.activePrimary) return;
    const initialActiveSwatch = card.querySelector('.cs-swatch-link[data-initial-active="true"]');
    if (initialActiveSwatch) {
      card.dataset.activePrimary = initialActiveSwatch.dataset.primaryImg || '';
      card.dataset.activeSecondary = initialActiveSwatch.dataset.secondaryImg || '';
    }
  }

  // =========================
  // CLICK → INSTANT METADATA + PRICE UPDATE
  // =========================
  document.addEventListener('click', function (e) {
    const swatch = e.target.closest('.cs-swatch-link');
    if (!swatch) return;

    e.preventDefault();

    const card = swatch.closest('product-card, .product-card, .product-item');
    if (!card) return;

    // Save active state locally to the card element context
    card.dataset.activePrimary = swatch.dataset.primaryImg || '';
    card.dataset.activeSecondary = swatch.dataset.secondaryImg || '';

    // Toggle active UI selection dots
    card.querySelectorAll('.swatch-item').forEach(item => {
      item.classList.remove('is-active');
    });
    swatch.closest('.swatch-item')?.classList.add('is-active');

    // Fire instant sync updates
    swapImages(card, swatch.dataset.primaryImg, swatch.dataset.secondaryImg);
    updateCardMetadata(card, swatch);
  });

  // =========================
  // HOVER → TEMPORARY IMAGE PREVIEW
  // =========================
  document.addEventListener('mouseover', function (e) {
    const swatch = e.target.closest('.cs-swatch-link');
    if (!swatch) return;

    const card = swatch.closest('product-card, .product-card, .product-item');
    if (!card) return;

    initializeCardState(card);
    swapImages(card, swatch.dataset.primaryImg, swatch.dataset.secondaryImg);
  }, true);

  // =========================
  // MOUSE OUT → RESTORE SAVED SELECTION
  // =========================
  document.addEventListener('mouseout', function (e) {
    const swatch = e.target.closest('.cs-swatch-link');
    if (!swatch) return;

    const card = swatch.closest('product-card, .product-card, .product-item');
    if (!card) return;

    initializeCardState(card);
    swapImages(card, card.dataset.activePrimary, card.dataset.activeSecondary);
  }, true);

})();